const OAUTH_RETURN_ROUTE_KEY = 'oauth_return_route'
const OAUTH_RETURN_ROUTE_MAX_AGE_MS = 30 * 60 * 1000

const OAUTH_CALLBACK_QUERY_KEYS = ['provider', 'oauth_result']

function sanitizeOauthReturnRoute(routeOrPath) {
  if (typeof window === 'undefined') return ''

  const rawPath = typeof routeOrPath === 'string'
    ? routeOrPath
    : routeOrPath?.fullPath || routeOrPath?.path || ''

  if (!rawPath || typeof rawPath !== 'string') return ''
  if (!rawPath.startsWith('/') || rawPath.startsWith('//')) return ''

  try {
    const url = new URL(rawPath, window.location.origin)

    if (url.origin !== window.location.origin) return ''

    OAUTH_CALLBACK_QUERY_KEYS.forEach(key => url.searchParams.delete(key))

    const search = url.searchParams.toString()
    return `${url.pathname}${search ? `?${search}` : ''}${url.hash || ''}`
  } catch {
    return ''
  }
}

export function saveOauthReturnRoute(routeOrPath) {
  if (typeof window === 'undefined') return

  const route = sanitizeOauthReturnRoute(routeOrPath)
  if (!route) return

  localStorage.setItem(
    OAUTH_RETURN_ROUTE_KEY,
    JSON.stringify({
      route,
      createdAt: Date.now(),
    })
  )
}

function readOauthReturnRoute() {
  if (typeof window === 'undefined') return ''

  const raw = localStorage.getItem(OAUTH_RETURN_ROUTE_KEY)
  if (!raw) return ''

  try {
    const parsed = JSON.parse(raw)
    const route = sanitizeOauthReturnRoute(parsed?.route || '')
    const createdAt = Number(parsed?.createdAt || 0)

    if (!route || !createdAt) return ''
    if (Date.now() - createdAt > OAUTH_RETURN_ROUTE_MAX_AGE_MS) return ''

    return route
  } catch {
    return ''
  }
}

export function clearOauthReturnRoute() {
  if (typeof window === 'undefined') return
  localStorage.removeItem(OAUTH_RETURN_ROUTE_KEY)
}

export function consumeOauthReturnRoute() {
  const route = readOauthReturnRoute()
  clearOauthReturnRoute()
  return route
}
